import { useEffect as u } from "react";
import c from "./useLatestCallback.js";
function n(r, t, s, e) {
  const a = c(s);
  u(() => (r.addEventListener(t, a, e), () => {
    r.removeEventListener(t, a);
  }), [r, t, e?.capture, e?.once, e?.passive, e?.signal]);
}
export {
  n as default
};
